import { isFeatureEnabled } from '@lumapps/features';
import { createSelector } from '@lumapps/redux/reselect';

import { NOTIFICATIONS_BETA } from '../constants';
import { LastNotification, NotificationCenter } from '../types';

export const isNotificationsBetaEnabled = isFeatureEnabled(NOTIFICATIONS_BETA);

const notificationCenterSelector = (state: FrontOfficeStore): NotificationCenter => state.notificationCenter || {};

const notificationGroupsSelector = createSelector(
    notificationCenterSelector,
    (notificationCenter: any) => notificationCenter.notificationGroups || [],
);

const unreadNotificationsCountSelector = createSelector(
    notificationCenterSelector,
    (notificationCenter) => notificationCenter.unreadNotificationsCount,
);

const hasNotificationsSelector = createSelector(notificationCenterSelector, (notificationCenter) =>
    Boolean(notificationCenter?.notificationGroups?.length > 0),
);

const lastNotificationSelector = createSelector(
    notificationCenterSelector,
    (notificationCenter): LastNotification => notificationCenter.lastNotification,
);

export {
    notificationCenterSelector,
    notificationGroupsSelector,
    unreadNotificationsCountSelector,
    hasNotificationsSelector,
    lastNotificationSelector,
};
